export const environment = {
  production: true,
  applicationName: "#{Release.EnvironmentName}#-growuseradmin-frontend",
  baseUrlOidcConfig: "#{Ng.Authority}#",
  baseUrlGrowApi: "#{Ng.BaseUrlGrowApi}#",
  appInsights: {
    instrumentationKey: '#{ApplicationInsights.InstrumentationKey}#'
  }
};
